var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNavigationNotifications(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.88 10.7812C34.4662 10.7812 35.5313 12.1781 35.5313 13.4794C35.5313 16.1194 31.1119 18.2812 31.0312 18.2812C30.9506 18.2812 26.5312 16.1194 26.5312 13.4794C26.5312 12.1781 27.5963 10.7812 29.1825 10.7812C30.09 10.7812 30.6862 11.205 31.0312 11.5837C31.3762 11.205 31.9725 10.7812 32.88 10.7812Z",
    stroke: "currentColor",
    strokeWidth: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1456 23.9907C29.6231 23.9907 28.1813 23.6551 26.8856 23.0532L20.6606 24.3751L21.9638 18.1388C21.3581 16.8413 21.0206 15.392 21.0206 13.8657",
    stroke: "currentColor",
    strokeWidth: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1342 23.9794C36.7198 23.9794 41.2498 19.4513 41.2498 13.8638C41.2498 8.27625 36.7217 3.75 31.1342 3.75C25.5467 3.75 21.0186 8.27813 21.0186 13.8656",
    stroke: "currentColor",
    strokeWidth: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5249 35.625H20.0999",
    stroke: "currentColor",
    strokeWidth: 1.4832,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.125 23.5294V37.0312C28.125 39.3619 26.2781 41.25 24 41.25H11.625C9.34687 41.25 7.5 39.3619 7.5 37.0312V11.7188C7.5 9.38812 9.34687 7.5 11.625 7.5H23.2744",
    stroke: "currentColor",
    strokeWidth: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavigationNotifications);
export default __webpack_public_path__ + "static/media/navigation-notifications.683e6adf.svg";
export { ForwardRef as ReactComponent };